import { render, staticRenderFns } from "./KitsCombo.vue?vue&type=template&id=f972b23c&"
import script from "./KitsCombo.vue?vue&type=script&lang=js&"
export * from "./KitsCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports